import { render, staticRenderFns } from "./SelectRoleModal.vue?vue&type=template&id=4bad8308&"
import script from "./SelectRoleModal.vue?vue&type=script&lang=js&"
export * from "./SelectRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports